import React, { Fragment } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';
import * as Yup from 'yup';
import numeral from 'numeral';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
    Avatar, Box,
    Button,
    Checkbox,
    colors,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    FormControlLabel,
    Grid,
    Icon,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Paper,
    Switch,
    TextField,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormLabel
} from '@material-ui/core';

import { BsFillPersonFill } from "react-icons/bs";
import TreeItem from '@material-ui/lab/TreeItem';
import TreeView from '@material-ui/lab/TreeView';
import { MdGroup } from "react-icons/md";
import { FaWaveSquare } from "react-icons/fa";
import { RiAlarmWarningLine } from "react-icons/ri";

const ColorCheckbox = withStyles({
    root: {
        marginLeft: 0,
        color: colors.blue[400],
        '&$checked': {
            color: colors.blue[500],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 400,
        minHeight: 400,
        padding: 20
    },
    treeviewleft: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 350,
        minHeight: 350,
        padding: 20
    },
    treeviewright: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 287,
        minHeight: 287,
        padding: 20
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    },
    rooticon: {
        width: 24,
        height: 24,
        marginRight: theme.spacing(2)
    },
}));

const lista = [];

const Mailing = ({ item, open, closeEdition, updateValues, dependencies, updateDependencies, checkedMailto, checkedExcludes, checkedIncludes, handleToggle }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth>
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Notificação
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Box
                        display="flex"
                        flexDirection="column"
                        height="100%"
                        justifyContent="center"
                    >
                        <Formik
                            initialValues={item}
                            validationSchema={
                                Yup.object().shape({
                                    name: Yup.string().max(255).required('Nome é obrigatório'),
                                    template: Yup.string().max(255).required('Tipo de notificação é o obrigatória'),
                                })
                            }
                            onSubmit={(values, formik) => {
                                values.mailto = checkedMailto;
                                updateValues(values);
                                formik.setSubmitting(false);
                            }}
                        >
                            {({
                                errors,
                                handleBlur,
                                handleChange,
                                handleSubmit,
                                isSubmitting,
                                touched,
                                values
                            }) => (
                                <form onSubmit={handleSubmit}>


                                    <Grid
                                        container
                                        spacing={2}
                                    >

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <Grid
                                                container
                                                spacing={1}
                                            >
                                                <Grid
                                                    item
                                                    md={12}
                                                    xs={12}>
                                                    <TextField
                                                        error={Boolean(touched.name && errors.name)}
                                                        fullWidth
                                                        helperText={touched.name && errors.name}
                                                        label="Nome"
                                                        rows={2}
                                                        multiline
                                                        margin="normal"
                                                        name="name"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.name}
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    md={6}
                                                    xs={12}>

                                                    <FormControl variant="outlined" fullWidth>
                                                        <InputLabel shrink htmlFor="template">Tipo de Notificação</InputLabel>
                                                        <Select notched
                                                            error={Boolean(touched.template && errors.template)}
                                                            required
                                                            fullWidth
                                                            label="Tipo de Notificação"
                                                            variant="outlined"
                                                            id="template"
                                                            name="template"
                                                            onBlur={handleBlur}
                                                            onChange={handleChange}
                                                            value={values.template}
                                                            inputProps={{
                                                                name: 'template',
                                                                id: 'template',
                                                            }}
                                                        >
                                                            {dependencies.templates.map((option) => (
                                                                <MenuItem key={option.name} value={option.name}>{option.label}</MenuItem>
                                                            ))}

                                                        </Select>
                                                    </FormControl>

                                                </Grid>

                                                <Grid
                                                    item
                                                    md={6}
                                                    xs={12}>
                                                    <Typography
                                                        color="textPrimary"
                                                        gutterBottom
                                                        variant="h6"
                                                    >
                                                        Habiltar / Desabilitar
                                                    </Typography>
                                                    <Switch
                                                        checked={values.enabled}
                                                        onChange={handleChange}
                                                        name="enabled" />
                                                </Grid>

                                                <Grid
                                                    item
                                                    md={12}
                                                    xs={12}>

                                                    <Paper variant="outlined" >
                                                        <FormControl component="fieldset" fullWidth >
                                                            <FormLabel style={{ padding: 10 }} >
                                                                Canais de Envio de Mensagens
                                                            </FormLabel>

                                                            <Divider></Divider>

                                                            <Grid container style={{ padding: 5 }}>
                                                                <Grid item>
                                                                    <FormControlLabel
                                                                        control={(
                                                                            <ColorCheckbox onChange={handleChange} name="toEmail" checked={values.toEmail} />
                                                                        )}
                                                                        label="Email"
                                                                    />
                                                                </Grid>

                                                                <Grid item>
                                                                    <FormControlLabel
                                                                        control={<ColorCheckbox onChange={handleChange} name="toWhatsApp" checked={values.toWhatsApp} />}
                                                                        label="Whatsapp"
                                                                    />
                                                                </Grid>

                                                                <Grid item>
                                                                    <FormControlLabel
                                                                        control={(
                                                                            <ColorCheckbox onChange={handleChange} name="toSMS" checked={values.toSMS} disabled />
                                                                        )}
                                                                        label="SMS"
                                                                    />
                                                                </Grid>

                                                                <Grid item>
                                                                    <FormControlLabel
                                                                        control={(
                                                                            <ColorCheckbox onChange={handleChange} name="toTelegram" checked={values.toTelegram} disabled />
                                                                        )}
                                                                        label="Telegram"
                                                                    />
                                                                </Grid>

                                                                <Grid item>
                                                                    <FormControlLabel
                                                                        control={(
                                                                            <ColorCheckbox onChange={handleChange} name="toPhoneCall" checked={values.toTelegram} disabled />
                                                                        )}
                                                                        label="Chamada Telefênica"
                                                                    />
                                                                </Grid>

                                                            </Grid>

                                                        </FormControl>

                                                    </Paper>

                                                </Grid>

                                                <Grid
                                                    item
                                                    md={12}
                                                    xs={12}>
                                                    <Paper variant="outlined" >
                                                        <FormControl component="fieldset" fullWidth >
                                                            <FormLabel style={{ padding: 10 }} >
                                                                Usuários de Destino ( {values.mailto.length} )
                                                            </FormLabel>

                                                            <Divider></Divider>

                                                            <TreeView
                                                                rounded className={classes.treeviewleft}
                                                                defaultCollapseIcon=
                                                                {<Icon className={classes.rooticon} component={MdGroup} style={{ color: colors.blue[400] }} ></Icon>}
                                                                defaultExpandIcon=
                                                                {<Icon className={classes.rooticon} component={MdGroup} style={{ color: colors.blue[400] }} ></Icon>}
                                                            >

                                                                {dependencies.groups.map((group, gindex) => {
                                                                    return (
                                                                        <TreeItem nodeId={`Group` + gindex} label={numeral(gindex + 1).format('00') + ' - ' + group.name}>

                                                                            {group.users.map((user, uindex) => {
                                                                                return (

                                                                                    <ListItem key={`User` + uindex} >
                                                                                        <ListItemAvatar>
                                                                                            <Avatar
                                                                                                className={classes.avatar}
                                                                                            >
                                                                                                {<Icon component={BsFillPersonFill} style={{ color: colors.blue[400] }} ></Icon>}
                                                                                            </Avatar>
                                                                                        </ListItemAvatar>
                                                                                        <ListItemText id={user._id} primary={user.firstname + ` ` + user.lastname}
                                                                                            secondary={`Email: [ ` + user.email + ` ]`} />

                                                                                        <ListItemSecondaryAction>
                                                                                            <ColorCheckbox
                                                                                                edge="end"
                                                                                                onChange={handleToggle(user._id, 'mailto')}
                                                                                                checked={checkedMailto.indexOf(user._id) != -1}
                                                                                                inputProps={{ 'aria-labelledby': user._id }}
                                                                                            />
                                                                                        </ListItemSecondaryAction>
                                                                                    </ListItem>

                                                                                );
                                                                            })}

                                                                        </TreeItem>

                                                                    );
                                                                })}

                                                            </TreeView>

                                                        </FormControl>
                                                    </Paper>

                                                </Grid>
                                            </Grid>

                                        </Grid>

                                        <Grid
                                            item
                                            style={{ paddingTop: 25 }}
                                            md={4}
                                            xs={12}>

                                            <Paper variant="outlined">
                                                <FormControl fullWidth >
                                                    <FormLabel style={{ padding: 10 }} >
                                                        Só enviar notificação caso ocorram falhas nos testes abaixo
                                                    </FormLabel>

                                                    <Divider></Divider>

                                                    <TreeView
                                                        style={{ minHeight: 602 }}
                                                        rounded className={classes.treeviewright}
                                                        defaultCollapseIcon=
                                                        {<Icon className={classes.rooticon} component={FaWaveSquare} style={{ color: colors.blue[600] }} ></Icon>}
                                                        defaultExpandIcon=
                                                        {<Icon className={classes.rooticon} component={FaWaveSquare} style={{ color: colors.blue[400] }} ></Icon>}
                                                    >

                                                        {dependencies.messages.map((message, gindex) => {
                                                            return (
                                                                <TreeItem nodeId={message._id} label={message.code + ' - ' + message.name}>

                                                                    {message.inputs.map((input, iindex) => {

                                                                        return input.tests.map((test, tindex) => {
                                                                            return (

                                                                                <ListItem key={test._id} >
                                                                                    <ListItemAvatar>
                                                                                        <Avatar
                                                                                            className={classes.avatar}
                                                                                        >
                                                                                            {<Icon component={RiAlarmWarningLine} style={{ color: colors.blue[400] }} ></Icon>}
                                                                                        </Avatar>
                                                                                    </ListItemAvatar>
                                                                                    <ListItemText id={test._id} primary={test.name}
                                                                                        secondary={test.description} />

                                                                                    <ListItemSecondaryAction>
                                                                                        <ColorCheckbox
                                                                                            edge="end"
                                                                                            onChange={handleToggle(test._id, 'includes')}
                                                                                            checked={checkedIncludes.indexOf(test._id) != -1}
                                                                                            inputProps={{ 'aria-labelledby': test._id }}
                                                                                        />
                                                                                    </ListItemSecondaryAction>
                                                                                </ListItem>

                                                                            );
                                                                        });
                                                                    })}

                                                                </TreeItem>

                                                            );
                                                        })}

                                                    </TreeView>

                                                </FormControl>

                                            </Paper>

                                        </Grid>

                                        <Grid
                                            item
                                            style={{ paddingTop: 25 }}
                                            md={4}
                                            xs={12}>


                                            <Paper variant="outlined" >
                                                <FormControl component="fieldset" fullWidth >
                                                    <FormLabel style={{ padding: 10 }} >
                                                        Não enviar notificação caso ocorram falhas nos testes abaixo
                                                    </FormLabel>

                                                    <Divider></Divider>


                                                    <TreeView
                                                        style={{ minHeight: 602 }}
                                                        rounded className={classes.treeviewright}
                                                        defaultCollapseIcon=
                                                        {<Icon className={classes.rooticon} component={FaWaveSquare} style={{ color: colors.blue[600] }} ></Icon>}
                                                        defaultExpandIcon=
                                                        {<Icon className={classes.rooticon} component={FaWaveSquare} style={{ color: colors.blue[400] }} ></Icon>}
                                                    >

                                                        {dependencies.messages.map((message, gindex) => {
                                                            return (
                                                                <TreeItem nodeId={`Message` + gindex} label={message.code + ' - ' + message.name}>

                                                                    {message.inputs.map((input, iindex) => {

                                                                        return input.tests.map((test, tindex) => {
                                                                            return (

                                                                                <ListItem key={'test_' + test._id} >
                                                                                    <ListItemAvatar>
                                                                                        <Avatar
                                                                                            className={classes.avatar}
                                                                                        >
                                                                                            {<Icon component={RiAlarmWarningLine} style={{ color: colors.blue[400] }} ></Icon>}
                                                                                        </Avatar>
                                                                                    </ListItemAvatar>
                                                                                    <ListItemText id={'label_test_' + test._id} primary={test.name}
                                                                                        secondary={test.description} />

                                                                                    <ListItemSecondaryAction>
                                                                                        <ColorCheckbox
                                                                                            edge="end"
                                                                                            onChange={handleToggle(test._id, 'excludes')}
                                                                                            checked={checkedExcludes.indexOf(test._id) != -1}
                                                                                            inputProps={{ 'aria-labelledby': test._id }}
                                                                                        />
                                                                                    </ListItemSecondaryAction>
                                                                                </ListItem>

                                                                            );
                                                                        });
                                                                    })}

                                                                </TreeItem>

                                                            );
                                                        })}

                                                    </TreeView>

                                                </FormControl>

                                            </Paper>

                                        </Grid>

                                    </Grid>

                                    <Box my={1}></Box>

                                    <Divider />

                                    <Box my={1}>
                                        <Grid container
                                            direction="row"
                                            justify="flex-end"
                                            alignItems="baseline"
                                            spacing={1}  >
                                            <Grid item >
                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    type="submit"
                                                    variant="contained">
                                                    Salvar
                                                </Button>
                                            </Grid>
                                            <Grid item >
                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    variant="contained"
                                                    onClick={() => { closeEdition() }}>
                                                    Cancelar
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Box>

                                </form>
                            )}
                        </Formik>
                    </Box>

                </DialogContent>

            </Dialog>

        </Fragment >
    );
};

export default Mailing;
